/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Resource_ApiInputs */

const en_directory_agents_resource_api = /** @type {(inputs: Directory_Agents_Resource_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All REST endpoints, scopes, and error codes for project-scoped access.`)
};

const zh_directory_agents_resource_api = /** @type {(inputs: Directory_Agents_Resource_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目级访问的全部 REST 端点、权限与错误码。`)
};

/**
* | output |
* | --- |
* | "All REST endpoints, scopes, and error codes for project-scoped access." |
*
* @param {Directory_Agents_Resource_ApiInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_resource_api = /** @type {((inputs?: Directory_Agents_Resource_ApiInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Resource_ApiInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_resource_api(inputs)
	return zh_directory_agents_resource_api(inputs)
});
export { directory_agents_resource_api as "directory.agents.resource_api" }